import React, {useState} from 'react';
import {ReactComponent as LogoDark} from '../../resources/img/logoDark.svg';
import {ReactComponent as HMenu} from '../../resources/img/hMenu.svg';
import {CSS} from '../../utils/domUtils';
import ButtonDark from '../common/ButtonDark';
import { PATHS } from '../../utils/paths';
import { Link } from 'react-router-dom';
import SideMenu from '../common/SideMenu';
import '../../styles/homePage/_titleCard.scss';

const TitleCard = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <>
      <div className={CSS.SIDE_MENU} style={{ width: isMenuOpen ? '100%' : 0 }}>
        <SideMenu setIsMenuOpen={setIsMenuOpen} />
      </div>
      <div className={`${CSS.TITLE_CARD} ${CSS.BACKGROUND}`}>
        <div className={CSS.CONTAINER}>
          <div className={CSS.HEADER}>
            <Link to={PATHS.HOME}><LogoDark className={CSS.LOGO_DARK}/></Link>
            <ButtonDark buttonText={'Contact us'} to={PATHS.CONTACT} extraClasses={CSS.CONTACT_BUTTON}/>
            <HMenu className={CSS.MENU_BUTTON} onClick={() => setIsMenuOpen(true)}/>
          </div>
          <div className={`${CSS.TITLE_CARD_TITLE} ${CSS.CARD_TITLE}`}>
            Connecting data, protecting privacy
            <ButtonDark buttonText={'Our Platform'} to={PATHS.COMING_SOON} extraClasses={`${CSS.DISPLAY_BIGSCREEN} ${CSS.OUR_PLATFORM_BUTTON}`} hasArrow={true}/>
          </div>
          <div className={CSS.CARD_SUBTITLE}>
            Valuable insights can often only be found by sharing data - but accessing external
            information without compromising privacy can be challenging. <b>xtendr changes that.</b>
          </div>
          <ButtonDark
            buttonText={'Our Platform'}
            extraClasses={`${CSS.DISPLAY_SMALLSCREEN}
            ${CSS.OUR_PLATFORM_BUTTON}`}
            to={PATHS.COMING_SOON}
            hasArrow={true}
          />
          </div>
      </div>
    </>
  )
};

export default TitleCard;
